export default {"src":"/_next/static/image/public/images/ic_pending_orange.f5f11d7ecf094782ca96c4ccd2e8428a.svg","height":22,"width":22};